// Nova Scotia cities & towns — comprehensive coverage list for SEO.
export const cities = [
  {
    slug: "halifax",
    name: "Halifax",
    region: "Halifax Regional Municipality",
    population: "108,000+",
    tagline: "Nova Scotia's capital — where our largest teams stand watch.",
    keywords: [
      "security guards Halifax",
      "security company Halifax Nova Scotia",
      "24/7 security services Halifax",
      "mobile patrol Halifax",
      "event security Halifax",
      "corporate security Halifax",
      "waterfront security Halifax",
    ],
    intro: "Halifax anchors our operation. From the Barrington Street financial district to the Halifax Seaport, from Dalhousie's campuses to the Bayers Lake business park, we field the largest uniformed security roster in the province.",
    body: [
      "Downtown Halifax presents a dense mix of Class-A office towers, residential highrises, hospitality venues, and public spaces. Our officers work with property managers along Spring Garden, Argyle, and Barrington to deliver consistent, respectful, downtown-appropriate security.",
      "The Port of Halifax is one of the deepest natural harbours in the world and one of North America's most active container gateways. We support ISPS-informed marine security across the port terminals, cruise berths at Pier 20, and adjacent shipyards.",
      "Halifax's event calendar — the Halifax Jazz Festival, the Halifax Busker Festival, the Scotiabank Centre concert schedule, and Nova Scotia Tattoo — keeps our event team booked from spring to autumn. We handle credentialing, crowd management, backstage protection, and post-event debriefs.",
      "Beyond the downtown core, we cover Bayers Lake, Burnside, Dartmouth Crossing, Clayton Park, and the industrial arteries running toward the airport.",
    ],
  },
  {
    slug: "dartmouth",
    name: "Dartmouth",
    region: "Halifax Regional Municipality",
    population: "68,000+",
    tagline: "The city of lakes — and the industrial engine across the harbour.",
    keywords: [
      "security guards Dartmouth",
      "Burnside industrial security",
      "Dartmouth mobile patrol",
      "commercial security Dartmouth",
      "loss prevention Dartmouth",
    ],
    intro: "Dartmouth's Burnside Industrial Park is the largest industrial park east of Montreal. Our officers patrol its warehouses, distribution centres, and manufacturing floors around the clock.",
    body: [
      "Burnside is a distinct security environment — high traffic during the day, isolated and quiet at night, with an enormous concentration of goods, tools, and vehicles. We deliver mobile patrols on custom routes, standing officers at high-value tenants, and rapid-response alarm callouts.",
      "Dartmouth Crossing, the province's largest shopping and dining destination, is served by our retail loss prevention and mobile patrol teams.",
      "Along the Dartmouth waterfront, we cover ferry terminals, hospitality venues, and events at Alderney Landing.",
    ],
  },
  {
    slug: "sydney",
    name: "Sydney",
    region: "Cape Breton Regional Municipality",
    population: "29,000+",
    tagline: "The heart of Cape Breton — port, cruise, industry.",
    keywords: [
      "security guards Sydney NS",
      "Cape Breton security",
      "port security Sydney",
      "cruise ship security Sydney",
      "industrial security Cape Breton",
    ],
    intro: "Sydney is Cape Breton's economic hub — a working port, a growing cruise homeport, and a service centre for the industries that shaped Nova Scotia's east.",
    body: [
      "We staff the Sydney Marine Terminal during cruise season with ISPS-informed teams. Homeporting and transit calls both require careful gangway, provisioning, and crew-change management.",
      "Sydney's downtown and Charlotte Street corridor benefit from our uniformed presence at retail and hospitality clients.",
      "Across CBRM — Glace Bay, New Waterford, North Sydney, Sydney Mines — our mobile patrols cover industrial legacy sites, wind assets, and community-facing venues.",
    ],
  },
  { slug: "truro", name: "Truro", region: "Colchester County", population: "12,000+" },
  { slug: "new-glasgow", name: "New Glasgow", region: "Pictou County", population: "9,000+" },
  { slug: "glace-bay", name: "Glace Bay", region: "Cape Breton Regional Municipality", population: "16,000+" },
  { slug: "kentville", name: "Kentville", region: "Kings County", population: "6,000+" },
  { slug: "amherst", name: "Amherst", region: "Cumberland County", population: "9,500+" },
  { slug: "bridgewater", name: "Bridgewater", region: "Lunenburg County", population: "8,900+" },
  { slug: "yarmouth", name: "Yarmouth", region: "Yarmouth County", population: "6,500+" },
  { slug: "antigonish", name: "Antigonish", region: "Antigonish County", population: "4,300+" },
  { slug: "wolfville", name: "Wolfville", region: "Kings County", population: "5,000+" },
  { slug: "digby", name: "Digby", region: "Digby County", population: "2,000+" },
  { slug: "windsor", name: "Windsor", region: "Hants County", population: "3,700+" },
  { slug: "pictou", name: "Pictou", region: "Pictou County", population: "3,000+" },
  { slug: "stellarton", name: "Stellarton", region: "Pictou County", population: "4,300+" },
  { slug: "lunenburg", name: "Lunenburg", region: "Lunenburg County", population: "2,300+" },
  { slug: "liverpool", name: "Liverpool", region: "Queens County", population: "2,600+" },
  { slug: "shelburne", name: "Shelburne", region: "Shelburne County", population: "1,700+" },
  { slug: "berwick", name: "Berwick", region: "Kings County", population: "2,500+" },
  { slug: "middleton", name: "Middleton", region: "Annapolis County", population: "1,800+" },
  { slug: "springhill", name: "Springhill", region: "Cumberland County", population: "2,900+" },
  { slug: "parrsboro", name: "Parrsboro", region: "Cumberland County", population: "1,300+" },
  { slug: "port-hawkesbury", name: "Port Hawkesbury", region: "Inverness County", population: "3,200+" },
  { slug: "inverness", name: "Inverness", region: "Inverness County", population: "1,300+" },
  { slug: "baddeck", name: "Baddeck", region: "Victoria County", population: "800+" },
  { slug: "chester", name: "Chester", region: "Lunenburg County", population: "1,500+" },
  { slug: "mahone-bay", name: "Mahone Bay", region: "Lunenburg County", population: "1,000+" },
  { slug: "tatamagouche", name: "Tatamagouche", region: "Colchester County", population: "700+" },
  { slug: "pugwash", name: "Pugwash", region: "Cumberland County", population: "700+" },
  { slug: "bedford", name: "Bedford", region: "Halifax Regional Municipality", population: "16,000+" },
  { slug: "cole-harbour", name: "Cole Harbour", region: "Halifax Regional Municipality", population: "26,000+" },
  { slug: "sackville", name: "Sackville", region: "Halifax Regional Municipality", population: "26,000+" },
  { slug: "bible-hill", name: "Bible Hill", region: "Colchester County", population: "5,000+" },
  { slug: "westville", name: "Westville", region: "Pictou County", population: "3,700+" },
  { slug: "trenton", name: "Trenton", region: "Pictou County", population: "2,600+" },
  { slug: "oxford", name: "Oxford", region: "Cumberland County", population: "1,100+" },
  { slug: "north-sydney", name: "North Sydney", region: "Cape Breton Regional Municipality", population: "5,300+" },
  { slug: "louisbourg", name: "Louisbourg", region: "Cape Breton Regional Municipality", population: "1,000+" },
  { slug: "new-waterford", name: "New Waterford", region: "Cape Breton Regional Municipality", population: "7,000+" },
  { slug: "dominion", name: "Dominion", region: "Cape Breton Regional Municipality", population: "1,500+" },
  { slug: "sydney-mines", name: "Sydney Mines", region: "Cape Breton Regional Municipality", population: "13,500+" },
  { slug: "musquodoboit-harbour", name: "Musquodoboit Harbour", region: "Halifax Regional Municipality", population: "900+" },
  { slug: "fall-river", name: "Fall River", region: "Halifax Regional Municipality", population: "3,200+" },
  { slug: "elmsdale", name: "Elmsdale", region: "East Hants", population: "2,700+" },
  { slug: "enfield", name: "Enfield", region: "East Hants", population: "1,500+" },
  { slug: "hantsport", name: "Hantsport", region: "Hants County", population: "1,200+" },
  { slug: "hubbards", name: "Hubbards", region: "Halifax Regional Municipality", population: "1,000+" },
  { slug: "tantallon", name: "Tantallon", region: "Halifax Regional Municipality", population: "3,000+" },
  { slug: "timberlea", name: "Timberlea", region: "Halifax Regional Municipality", population: "8,500+" },
  { slug: "beaver-bank", name: "Beaver Bank", region: "Halifax Regional Municipality", population: "10,000+" },
  { slug: "eastern-passage", name: "Eastern Passage", region: "Halifax Regional Municipality", population: "10,000+" },
  { slug: "porters-lake", name: "Porters Lake", region: "Halifax Regional Municipality", population: "3,300+" },
  { slug: "sheet-harbour", name: "Sheet Harbour", region: "Halifax Regional Municipality", population: "800+" },
  { slug: "canso", name: "Canso", region: "Guysborough County", population: "700+" },
  { slug: "guysborough", name: "Guysborough", region: "Guysborough County", population: "400+" },
  { slug: "sherbrooke", name: "Sherbrooke", region: "Guysborough County", population: "300+" },
  { slug: "mulgrave", name: "Mulgrave", region: "Guysborough County", population: "700+" },
  { slug: "annapolis-royal", name: "Annapolis Royal", region: "Annapolis County", population: "500+" },
  { slug: "bridgetown", name: "Bridgetown", region: "Annapolis County", population: "900+" },
  { slug: "clark's-harbour", name: "Clark's Harbour", region: "Shelburne County", population: "700+" },
  { slug: "lockeport", name: "Lockeport", region: "Shelburne County", population: "500+" },
  { slug: "stewiacke", name: "Stewiacke", region: "Colchester County", population: "1,400+" },
  { slug: "westmount", name: "Westmount", region: "Cape Breton Regional Municipality", population: "3,000+" },
  { slug: "eskasoni", name: "Eskasoni", region: "Cape Breton Regional Municipality", population: "4,400+" },
];

export const getCity = (slug) => cities.find((c) => c.slug === slug);
